import { FormInstance } from 'antd';
import { Order } from 'constants/interface';
import {
  DeliveryTypeDisplayMapping,
  DeliveryTypeEnum,
  OrderOtherStatusEnum,
  OrderTypeDisplayMapping,
  OrderTypeEnum,
} from 'constants/order';
import { useUserOrganizations } from 'hooks/userOrganizations';
import React from 'react';
import { Select } from 'UI';

import {
  FormContainer,
  BaseFormItem,
  HorizontalContainer,
} from './style';

export interface OrderInfoFormData {
  type: OrderTypeEnum
  organization: string
  deliveryType: DeliveryTypeEnum
}

interface OrderInfoProps {
  formHandler: FormInstance<OrderInfoFormData>
  isLoading: boolean,
  initialOrder?: Order
  onOrderTypeChange?: (type: OrderTypeEnum) => void
}

const OrderInfo = ({
  formHandler,
  initialOrder,
  onOrderTypeChange = () => {},
  isLoading: externalLoading,
}: OrderInfoProps): JSX.Element => {
  const organizationList = useUserOrganizations();

  const defaultOrgId = organizationList.length > 0
    ? organizationList[0]?.id
    : undefined;

  const isActiveOrderCanceled = initialOrder?.status === OrderOtherStatusEnum.CANCELED;

  return (
    <FormContainer
      form={formHandler}
      layout="vertical"
      initialValues={{
        type: initialOrder?.type || OrderTypeEnum.REGULAR,
        organization: initialOrder?.organization.id || defaultOrgId,
        deliveryType: initialOrder?.deliveryType || DeliveryTypeEnum.DELIVERY,
      }}
    >
      <HorizontalContainer>
        <BaseFormItem
          label="Tipo de formação"
          name="type"
        >
          <Select
            onSelect={(type: OrderTypeEnum) => onOrderTypeChange(type)}
            disabled={externalLoading || isActiveOrderCanceled}
          >
            {Object.values(OrderTypeEnum).map((orderType) => (
              <Select.Option
                key={orderType}
                value={orderType}
              >
                {`${OrderTypeDisplayMapping[orderType].name}`}
              </Select.Option>
            ))}
          </Select>
        </BaseFormItem>
        <BaseFormItem
          label="Unidade de produção"
          name="organization"
        >
          <Select
            disabled={externalLoading || isActiveOrderCanceled}
          >
            {organizationList.map((org) => (
              <Select.Option
                key={org.id}
                value={org.id}
              >
                {`${org.name}`}
              </Select.Option>
            ))}
          </Select>
        </BaseFormItem>
        <BaseFormItem
          label="Entrega"
          name="deliveryType"
        >
          <Select
            disabled={externalLoading || isActiveOrderCanceled}
          >
            {Object.values(DeliveryTypeEnum).map((deliveryType) => (
              <Select.Option
                key={deliveryType}
                value={deliveryType}
              >
                {`${DeliveryTypeDisplayMapping[deliveryType].name}`}
              </Select.Option>
            ))}
          </Select>
        </BaseFormItem>
      </HorizontalContainer>
    </FormContainer>
  );
};

export default OrderInfo;
